import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import {
  ResponseAddDto,
  ResponseAllowanceDto,
  ResponseDeleteDto,
  ResponseDestinationDto,
  ResponseHistoryDto,
  ResponseSaveDto,
  ResponseCompanySettingDto,
  RequestUpdatePost,
  ResponseListLocationDto,
  ResponseShowLocationDto,
} from "../dto/on-duty.api";

@Injectable()
export class OnDutyApi {
  private readonly service: string = '';
  private readonly model: string = 'sf6s/onduty';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public history(empId: string, limit: string | number, skip: string | number): Observable<ResponseHistoryDto> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public schedule(empId: string, date: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'schedule';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof date !== 'undefined' && date !== null) urlParams.date = date;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body, null, 150000);
  }

  public historyDetail(empId: string, limit: string | number, skip: string | number): Observable<any> {
    const method: string = 'GET';
    const func: string = 'history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public destination(companyId: string, textSearch: string, limit: string | number, skip: string | number): Observable<ResponseDestinationDto> {
    const method: string = 'GET';
    const func: string = 'destination';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) urlParams.companyId = companyId;
    if (typeof textSearch !== 'undefined' && textSearch !== null) urlParams.textSearch = textSearch;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDestinationDto>(method, url, func, params, body);
  }

  public allowance(purposeCode: string, empId?: string): Observable<ResponseAllowanceDto> {
    const method: string = 'GET';
    const func: string = 'allowance';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof purposeCode !== 'undefined' && purposeCode !== null) urlParams.purposeCode = purposeCode;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAllowanceDto>(method, url, func, params, body, null, 1000000);
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseDeleteDto> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDto>(method, url, params, urlParams, body);
  }

  public companySetting(): Observable<ResponseCompanySettingDto> {
    const method: string = 'GET';
    const func: string = 'companySetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCompanySettingDto>(method, url, func, params, body);
  }

  public updatePost(fileName: string, requestNo: string): Observable<RequestUpdatePost> {
    const method: string = 'POST';
    const func: string = 'updatePost';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) urlParams.fileName = fileName;
    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public showAttLocation(): Observable<ResponseShowLocationDto> {
    const method: string = 'GET';
    const func: string = 'showAttLocation';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseShowLocationDto>(method, url, func, params, body);
  }

  public listAttLocation(payload: any): Observable<ResponseListLocationDto> {
    const method: string = 'GET';
    const func: string = 'listAttLocation';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListLocationDto>(method, url, params, urlParams, body);
  }

  public feedOnduty(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedOnduty';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/on-duty.api.ts